import { Input, OnDestroy, OnInit, Directive } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { SmpError } from '@app/shared/models/smp-error';
import { Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { LogicOp, Permission, Page } from '@app/core/authentication/permission';

@Directive()
export abstract class BaseComponent implements OnInit, OnDestroy {

  protected logStyle = 'color: #427f9c; background-color: #bfcf4f;';

  @Input()
  public disabled?: boolean;

  @Input()
  public readonly?: boolean;

  protected _idPrefix: string;

  @Input()
  public idPrefix?: string; // Property to use in case multiple components of the same type are used to prevent duplicate id's on a page

  @Input()
  public idSuffix?: string; // Property to use in case multiple components of the same type are used to prevent duplicate id's on a page

  protected subscriptions: Subscription[];

  protected constructor() {
    this.subscriptions = new Array<Subscription>();
  }

  get Page() {
    return Page;
  }

  get Permission() {
    return Permission;
  }

  get LogicOp() {
    return LogicOp;
  }

  public ngOnInit() {
    this.idPrefix = `${this.idPrefix || ''}${this._idPrefix  || ''}`;
    this.idSuffix = this.idSuffix || '';
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  protected handleError(error: HttpErrorResponse | Error | string): void {
    const name = this.constructor.name;
    const errorPrefix = error instanceof HttpErrorResponse ? 'HttpErrorResponse received' : 'Error encountered';
    const messageToShow = error instanceof HttpErrorResponse ? `${error.status} (${error.statusText}) ` +
                          `- CODE: ${ error.error ? (<SmpError>error.error).additional_code : 'UNDEFINED'}, MESSAGE: ${ error.error ? error.error.message : 'UNDEFINED'}` :
                         (error instanceof Error ? error.message : error);

    console.debug(`%c${name} - ${errorPrefix}: ${messageToShow}`, this.logStyle);

    if (!environment.production) {
      throw error;
    }
  }
}
